import _defineProperty from "/Users/jamieschaedel/Sites/htb/htb-gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty.js";
import _slicedToArray from "/Users/jamieschaedel/Sites/htb/htb-gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import "core-js/modules/es.array.reduce.js";
import "core-js/modules/es.array.sort.js";

var __rest = this && this.__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var addEachKeyValueToObject = function addEachKeyValueToObject(acc, _ref) {
  var _ref2 = _slicedToArray(_ref, 2),
      key = _ref2[0],
      value = _ref2[1];

  return Object.assign(Object.assign({}, acc), _defineProperty({}, key, value));
};

export function getFacets(docInfo) {
  if (!docInfo.facets) return {};
  return Object.entries(docInfo.facets).map(function (_ref3) {
    var _ref4 = _slicedToArray(_ref3, 2),
        facetName = _ref4[0],
        facetValue = _ref4[1];

    return [facetName, [{
      field: facetName,
      data: Object.entries(facetValue).map(function (_ref5) {
        var _ref6 = _slicedToArray(_ref5, 2),
            value = _ref6[0],
            count = _ref6[1];

        return {
          value: value,
          count: count
        };
      }),
      // Site Search does not support any other type of facet
      type: "value"
    }]];
  }).reduce(addEachKeyValueToObject, {});
}
export function getResults(records, documentType) {
  var isMetaField = function isMetaField(key) {
    return key.startsWith("_");
  };

  var toObjectWithRaw = function toObjectWithRaw(value) {
    return {
      raw: value
    };
  };

  return records[documentType].map(function (record) {
    var highlight = record.highlight,
        sort = record.sort,
        rest = __rest(record, ["highlight", "sort"]); //eslint-disable-line


    var result = Object.entries(rest).filter(function (_ref7) {
      var _ref8 = _slicedToArray(_ref7, 1),
          fieldName = _ref8[0];

      return !isMetaField(fieldName);
    }).map(function (_ref9) {
      var _ref10 = _slicedToArray(_ref9, 2),
          fieldName = _ref10[0],
          fieldValue = _ref10[1];

      return [fieldName, toObjectWithRaw(fieldValue)];
    }).reduce(addEachKeyValueToObject, {});
    Object.entries(highlight).forEach(function (_ref11) {
      var _ref12 = _slicedToArray(_ref11, 2),
          key = _ref12[0],
          value = _ref12[1];

      result[key].snippet = value;
    });
    return result;
  });
}